import { Outlet, useLocation } from 'react-router';

import Navbar from '@/components/Navbar';
import CurrentUserContextProvider from '@/Contexts/CurrentUser/Provider';
import PermissionsContextProvider from '@/Contexts/Permissions/Provider';
import 'esseal-data-table/style.css';
import ShortcutSpider from '@/components/ShortcutSpider';

import OnboardingRedirect from './OnboardingRedirect';
import { paths } from './paths';

import { useReactiveVar } from '@apollo/client/react';

import { rootRouteModeVar } from './reactiveRoutes';

const ContextualRoute: React.FC = () => {
  const location = useLocation();
  const isOnboarding = location.pathname === paths.onboarding;
  const mode = useReactiveVar(rootRouteModeVar);

  const content = (
    <OnboardingRedirect>
      {!isOnboarding && <Navbar />}
      <Outlet />
      {!isOnboarding && <ShortcutSpider />}
    </OnboardingRedirect>
  );

  return (
    <CurrentUserContextProvider>
      {mode === 'super' ? content : <PermissionsContextProvider>{content}</PermissionsContextProvider>}
    </CurrentUserContextProvider>
  );
};

export default ContextualRoute;
